import React from 'react';
import { View, Text } from 'react-native';
import { Tile } from 'react-native-elements';

export default function NewsDetailScreen() {
  return (
    <Tile
      imageSrc={require('../assets/images/1.jpeg')}
      title="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolores dolore exercitationem"
      featured
      caption="Some Caption Text"
    />
    // <View>
    //   <Text>this is news detail screen</Text>
    // </View>
  );
}
